const INSOFT_STATUSES = [
  { text: 'Not Initiated', value: 'none' },
  { text: 'Synchronizing', value: 'syncing' },
  { text: 'Success', value: 'success' },
  { text: 'Failed', value: 'failed' },
];
export default INSOFT_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/insoftStatuses.js